import { createVanIconComponent } from "./van"

const WarnOutlined = createVanIconComponent("warn-o")
export default WarnOutlined
